import { fetcher } from '../utils'

export default async (deviceToken: string): Promise<void> =>
  fetcher(`/api/notification/native/push/subscribe`, 'POST', deviceToken)
